var map = {
	"./1667331692600.jpg": 9257,
	"./ac856bc6ccd8712ae0a8712964ef7dca.jpg": 4763,
	"./beyo.jpg": 8008,
	"./chef.jpg": 8203,
	"./default.svg": 3685,
	"./egg.webp": 5169,
	"./kanye-animation.webp": 7650,
	"./play.jpg": 2272,
	"./rihanna.webp": 850,
	"./user.webp": 7240,
	"./user1.jpg": 8211,
	"./wed.webp": 2526,
	"./xtennt.jpg": 6489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7574;